/**
 * xDrop API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from "@angular/common/http";
import { CustomHttpParameterCodec } from "../encoder";
import { Observable } from "rxjs";

// @ts-ignore
import { CreateCustomerDto } from "../model/createCustomerDto";
// @ts-ignore
import { CustomerDto } from "../model/customerDto";
// @ts-ignore
import { CustomerPaginatedDto } from "../model/customerPaginatedDto";
// @ts-ignore
import { UpdateCustomerDto } from "../model/updateCustomerDto";

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";

@Injectable({
  providedIn: "root",
})
export class CustomersService {
  protected basePath = "http://localhost";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * Create a new customer
   * Creates a new customer.     &lt;br&gt;&lt;br&gt;     &lt;strong&gt;Possible error codes:&lt;/strong&gt;     &lt;ul&gt;       &lt;li&gt;&lt;strong&gt;CUSTOMER_INVALID_NOTIFICATION_CHANNEL&lt;/strong&gt;: No valid notification channel was provided (either email or phone number is required).&lt;/li&gt;       &lt;li&gt;&lt;strong&gt;CUSTOMER_DUPLICATE_ENTRY&lt;/strong&gt;: A customer with the same email or phone number already exists.&lt;/li&gt;       &lt;li&gt;&lt;strong&gt;SHOPIFY_INVALID_ID_FORMAT&lt;/strong&gt;: The Shopify ID retrieved from Shopify customer creation is invalid.&lt;/li&gt;     &lt;/ul&gt;
   * @param createCustomerDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerCreate(
    createCustomerDto: CreateCustomerDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomerDto>;
  public customerControllerCreate(
    createCustomerDto: CreateCustomerDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomerDto>>;
  public customerControllerCreate(
    createCustomerDto: CreateCustomerDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomerDto>>;
  public customerControllerCreate(
    createCustomerDto: CreateCustomerDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (createCustomerDto === null || createCustomerDto === undefined) {
      throw new Error("Required parameter createCustomerDto was null or undefined when calling customerControllerCreate.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Content-Type", httpContentTypeSelected);
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers`;
    return this.httpClient.request<CustomerDto>("post", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: createCustomerDto,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get paginated list of customers
   * @param page
   * @param limit
   * @param agencyId Agency ID
   * @param searchTerm
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerFindAll(
    page: number,
    limit: number,
    agencyId?: string,
    searchTerm?: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomerPaginatedDto>;
  public customerControllerFindAll(
    page: number,
    limit: number,
    agencyId?: string,
    searchTerm?: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomerPaginatedDto>>;
  public customerControllerFindAll(
    page: number,
    limit: number,
    agencyId?: string,
    searchTerm?: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomerPaginatedDto>>;
  public customerControllerFindAll(
    page: number,
    limit: number,
    agencyId?: string,
    searchTerm?: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (page === null || page === undefined) {
      throw new Error("Required parameter page was null or undefined when calling customerControllerFindAll.");
    }
    if (limit === null || limit === undefined) {
      throw new Error("Required parameter limit was null or undefined when calling customerControllerFindAll.");
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, "page");
    }
    if (limit !== undefined && limit !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>limit, "limit");
    }
    if (agencyId !== undefined && agencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>agencyId, "agencyId");
    }
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, "search_term");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers`;
    return this.httpClient.request<CustomerPaginatedDto>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get customers by email or phone number
   * Search for customers by email or phone number. Agency admins must provide agencyId to filter by their agency. Superadmins can search across all agencies by omitting agencyId.
   * @param value Email or phone number
   * @param agencyId Agency ID to filter results. Required for agency admins, optional for superadmins.
   * @param type Search type: \&#39;EMAIL\&#39; or \&#39;PHONE\&#39;. If not specified, auto-detects based on value format
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerFindByEmailOrPhoneNumber(
    value: string,
    agencyId?: string,
    type?: "EMAIL" | "PHONE",
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<CustomerDto>>;
  public customerControllerFindByEmailOrPhoneNumber(
    value: string,
    agencyId?: string,
    type?: "EMAIL" | "PHONE",
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<CustomerDto>>>;
  public customerControllerFindByEmailOrPhoneNumber(
    value: string,
    agencyId?: string,
    type?: "EMAIL" | "PHONE",
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<CustomerDto>>>;
  public customerControllerFindByEmailOrPhoneNumber(
    value: string,
    agencyId?: string,
    type?: "EMAIL" | "PHONE",
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (value === null || value === undefined) {
      throw new Error("Required parameter value was null or undefined when calling customerControllerFindByEmailOrPhoneNumber.");
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (agencyId !== undefined && agencyId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>agencyId, "agencyId");
    }
    if (type !== undefined && type !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>type, "type");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/search/${this.configuration.encodeParam({ name: "value", value: value, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<Array<CustomerDto>>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get customers by region ID
   * @param id Region ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerFindByRegion(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<CustomerDto>>;
  public customerControllerFindByRegion(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<CustomerDto>>>;
  public customerControllerFindByRegion(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<CustomerDto>>>;
  public customerControllerFindByRegion(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling customerControllerFindByRegion.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/region/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<Array<CustomerDto>>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get customers by zone ID
   * @param id Zone ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerFindByZone(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<Array<CustomerDto>>;
  public customerControllerFindByZone(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<Array<CustomerDto>>>;
  public customerControllerFindByZone(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<Array<CustomerDto>>>;
  public customerControllerFindByZone(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling customerControllerFindByZone.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/zone/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<Array<CustomerDto>>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Get customer by ID
   * @param id Customer ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerFindOne(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomerDto>;
  public customerControllerFindOne(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomerDto>>;
  public customerControllerFindOne(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomerDto>>;
  public customerControllerFindOne(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling customerControllerFindOne.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<CustomerDto>("get", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Delete a customer
   * Deletes a new customer.     &lt;br&gt;&lt;br&gt;     &lt;strong&gt;Possible error codes:&lt;/strong&gt;     &lt;ul&gt;       &lt;li&gt;&lt;strong&gt;SHOPIFY_CUSTOMER_DELETION_FAILED&lt;/strong&gt;: The customer could not be deleted on Shopify.&lt;/li&gt;     &lt;/ul&gt;
   * @param id Customer ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerRemove(
    id: string,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public customerControllerRemove(
    id: string,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public customerControllerRemove(
    id: string,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public customerControllerRemove(
    id: string,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling customerControllerRemove.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<any>("delete", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Update a customer
   * Updates a new customer.     &lt;br&gt;&lt;br&gt;     &lt;strong&gt;Possible error codes:&lt;/strong&gt;     &lt;ul&gt;       &lt;li&gt;&lt;strong&gt;SHOPIFY_CUSTOMER_UPDATE_FAILED&lt;/strong&gt;: The customer could not be updated on Shopify.&lt;/li&gt;     &lt;/ul&gt;
   * @param id Customer ID
   * @param updateCustomerDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public customerControllerUpdate(
    id: string,
    updateCustomerDto: UpdateCustomerDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<CustomerDto>;
  public customerControllerUpdate(
    id: string,
    updateCustomerDto: UpdateCustomerDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<CustomerDto>>;
  public customerControllerUpdate(
    id: string,
    updateCustomerDto: UpdateCustomerDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<CustomerDto>>;
  public customerControllerUpdate(
    id: string,
    updateCustomerDto: UpdateCustomerDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: "application/json"; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error("Required parameter id was null or undefined when calling customerControllerUpdate.");
    }
    if (updateCustomerDto === null || updateCustomerDto === undefined) {
      throw new Error("Required parameter updateCustomerDto was null or undefined when calling customerControllerUpdate.");
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (bearer) required
    localVarCredential = this.configuration.lookupCredential("bearer");
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set("Authorization", "Bearer " + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Accept", localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set("Content-Type", httpContentTypeSelected);
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    let localVarPath = `/customers/${this.configuration.encodeParam({ name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined })}`;
    return this.httpClient.request<CustomerDto>("patch", `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: updateCustomerDto,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
